import React, { useState, useEffect } from "react";
import { Typography, Box, Button, Menu, MenuItem } from "@mui/material";
import TopCreators from "../../common/TopCreators/TopCreators";
import PropTypes from "prop-types";
import styles from "./TopSelling.module.css";
import { apiFetch, API_BASE } from "../../../utils/api";
import * as Sentry from "@sentry/react";

const filterOptions = [
  { label: "last 7 days", value: "7d" },
  { label: "last 30 days", value: "30d" },
  { label: "last day", value: "1d" },
];

const TopSelling = ({ className = "" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0]);
  const [topCreatorsData, setTopCreatorsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await apiFetch(
          `/creators/top-selling?timeframe=${selectedFilter.value}`
        );
        setTopCreatorsData(data ?? []);
      } catch (error) {
        Sentry.captureException(error);
        console.error("❌ Failed to fetch top creators:", error);
      }
    };

    fetchData();
  }, [selectedFilter]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    setSelectedFilter(option);
    handleClose();
  };

  return (
    <section className={[styles.topSelling, className].join(" ")}>
      <Box className={styles.title}>
        <Typography className={`${styles.topSellingLabel} bold-text`}>
          Top creators in
        </Typography>
        <Typography className={`${styles.topSellingLabel1} bold-text`}>
          {selectedFilter.label}
        </Typography>
        <Typography className={styles.arrow} onClick={handleClick}>
          
        </Typography>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          {filterOptions.map((option) => (
            <MenuItem key={option.value} onClick={() => handleMenuItemClick(option)}>
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      </Box>

        {topCreatorsData.length === 0 ? (
          <Typography className={styles.noDataText}>
            No data available for selected timeframe.
          </Typography>
        ) : (
          <Box className={styles.grid}>
            {topCreatorsData.map((creator) => (
              <div className="grid-item" key={creator.number}>
                <TopCreators
                  number={creator.number}
                  logo={`${API_BASE}${creator.image}`}
                  name={creator.name}
                  totalSales={creator.totalSales}
                  creatorId={creator.creatorId}
                  descriptor={creator.descriptor}
                  change={creator.change}
                />
              </div>
            ))}
        </Box>
        )}

      {/* <Button className={styles.buttonsLabelFilledRest}>Load More</Button> */}
    </section>
  );
};

TopSelling.propTypes = {
  className: PropTypes.string,
};

export default TopSelling;
